<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>回款管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               :rules="searchRules"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="回款ID"
                        prop="id">
            <el-input style="width: 100%;"
                      v-model="search.id"
                      clearable
                      placeholder="请输入回款ID搜索">
            </el-input>
          </el-form-item>
          <el-form-item label="客户名称"
                        prop="customerid">
            <remote-select style="width: 100%;"
                           v-model="search.customerid"
                           filterable
                           remote
                           clearable
                           id-key="number"
                           keyword-key="name"
                           :label="(item) => {return item.name + '/' + item.number}"
                           value-key="id"
                           placeholder="请输入客户名称/编号搜索"
                           :query-request="customerRemoteMethod"
                           :find-request="getCustomerInfoRemote">
            </remote-select>
          </el-form-item>
          <el-form-item label="客户开票信息"
                        prop="receipt_info_id">
            <remote-select style="width: 100%;"
                           v-model="search.receipt_info_id"
                           filterable
                           remote
                           clearable
                           id-key="id"
                           keyword-key="company_name"
                           label-key="company_name"
                           value-key="id"
                           placeholder="请输入开票信息名称/ID搜索"
                           :query-request="receiptInfoForRemote"
                           :find-request="getCustomerReceiptDetail">
            </remote-select>
          </el-form-item>
          <el-form-item label="回款金额">
            <el-col :span="11">
              <el-form-item prop="collection_amount_min">
                <el-input v-model="search.collection_amount_min"
                          clearable
                          placeholder="请输入含税金额起始值" />
              </el-form-item>
            </el-col>
            <el-col :span="1">
              <div>&nbsp;&nbsp;至&nbsp;&nbsp;</div>
            </el-col>
            <el-col :span="11" :offset="1">
              <el-form-item prop="collection_amount_max">
                <el-input v-model="search.collection_amount_max"
                          clearable
                          placeholder="请输入含税金额结束值" />
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="回款描述"
                        prop="desc">
            <el-input style="width: 100%;"
                      v-model="search.desc"
                      clearable
                      placeholder="请输入回款描述关键字搜索">
            </el-input>
          </el-form-item>
          <el-form-item label="发起人"
                        prop="creator_id">
            <remote-select style="width: 100%;"
                           v-model="search.creator_id"
                           filterable
                           remote
                           clearable
                           id-key="id"
                           keyword-key="name"
                           label-key="name"
                           value-key="id"
                           placeholder="请输入名称搜索"
                           :query-request="(_)=>getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 3, 4, 5]}))"
                           :find-request="getPlatformUsersDetail">
            </remote-select>
          </el-form-item>
          <el-form-item label="创建时间"
                        prop="created_at">
            <el-date-picker v-model="search.created_at"
                            style="width: 100%;"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            align="right"
                            :default-time="['00:00:00', '23:59:59']"
                            value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="收款公司"
                        prop="our_company_id">
            <remote-select
              v-model="search.our_company_id"
              class="width-max"
              clearable
              id-key="id"
              keyword-key="name"
              label-key="name"
              value-key="id"
              placeholder="仅支持搜索启用中的收款公司,可输入名称进行搜索"
              :query-request="(_)=>fetchOurCompanies(Object.assign(_, {is_disabled: 0}))"
              :find-request="getOurCompaniesDetail">
            </remote-select>
          </el-form-item>
          <el-form-item label="核销状态"
                        prop="receipt_related_status">
            <el-select v-model="search.receipt_related_status"
                       clearable
                       class="width-max">
              <el-option v-for="(value, key) in receiptRelatedStatus"
                         :key="key"
                         :label="value"
                         :value="key">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="回款时间"
                        prop="received_date">
            <el-date-picker v-model="search.received_date"
                            style="width: 100%;"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            align="right"
                            :default-time="['00:00:00', '23:59:59']"
                            value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
          <el-button @click="resetSearch()">重置
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <div class="margin b15">
        <el-button v-if="isApprovePage"
                    type="primary"
                    icon="sj-icon-add"
                    size="small"
                    @click="$router.push(`/${routerPath}/create`)">新增回款
        </el-button>
        <el-button type="primary"
                    size="small"
                    v-if="this.$route.query.old_export"
                    @click="onExportSearch()">回款列表导出
        </el-button>
        <el-button type="primary"
                   icon="sj-icon-export"
                   size="small"
                   @click="exportCollectionList()">回款列表导出
        </el-button>
        <el-button type="primary"
                    size="small"
                    @click="showSummaryVisible()">按搜索结果汇总
        </el-button>
        <el-button type="primary"
                   size="small"
                   v-if="this.$route.query.old_export"
                   @click="onExportRelatedDetail()">回款核销明细导出
        </el-button>
        <el-button type="primary"
                   icon="sj-icon-export"
                   size="small"
                   @click="exportCollectionDetail()">回款核销明细导出
        </el-button>
      </div>
      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">

        <template v-for="(attr, index) of fields">
          <el-table-column v-bind="attr"></el-table-column>
        </template>
        <el-table-column fixed="right"
                         :width="isApprovePage ? 170 : 80"
                         label="操作">
          <template slot-scope="scope">
            <div class="button-gutter">
              <button-gutter>
                <el-button type="primary"
                           @click="$router.push(`/${routerPath}/detail/${scope.row.id}`)"
                           size="mini">查看
                </el-button>
                <el-button type="primary"
                           v-if="isApprovePage && scope.row.receipt_related_status===0"
                           @click="$router.push(`/${routerPath}/update/${scope.row.id}`)"
                           size="mini">修改
                </el-button>
                <el-button type="warning"
                           v-if="isApprovePage && scope.row.receipt_related_status!==2"
                           @click="showForceFinish(scope.row)"
                           size="mini">特殊核销
                </el-button>
              </button-gutter>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
    <payment-summary-dialog
      title="回款统计"
      :visible="summaryVisible"
      :data="paymentSummary"
      @closeDialog="summaryVisible = false"></payment-summary-dialog>

    <force-finish-dialog
      :visible=forceFinishVisible
      :collectionData="currentCollection"
      @refreshPage="onRefresh()"
      @closeDialog="closeForceFinishDialog">
    </force-finish-dialog>

  </div>
</template>

<script>
import { searchRules } from '../received-payment.rules.js'
import receivedPaymentMixins from '../received-payment.mixins'
import dateTimePicker from '@core/mixins/dateTimePicker'
import table, {removeEmptyParams} from '@core/mixins/table-v3'
import PaymentSummaryDialog from '@/views/received-payment/components/PaymentSummaryDialog'
import ForceFinishDialog from '@/views/received-payment/components/ForceFinishDialog'
import moment from 'moment'

export default {
  components: {
    PaymentSummaryDialog, ForceFinishDialog
  },
  mixins: [table, dateTimePicker, receivedPaymentMixins],
  data () {
    return {
      searchRules,
      search: {
        id: null,
        customerid: null,
        created_at: [],
        received_date: [],
        creator_id: null,
        collection_amount_min: null,
        collection_amount_max: null,
        desc: null,
        our_company_id: null,
        receipt_related_status: null,
        receipt_info_id: null,
        is_from_finance: this.$route.meta.type === 'approval' ? 1 : 0,
      },
      searchFieldType: {
        received_payment_status: Number,
        creator_id: Number,
        receipt_info_id: Number,
      },
      paymentCompanies: {},
      paymentSummary: [],
      summaryVisible: false,
      currentCollection: {},
      forceFinishVisible: false,
    }
  },
  computed: {
    ...Vuex.mapState({
      collectionTypeText: state => state.receivedPayment.collectionTypeText,
    }),
    routerPath () {
      return `received-${this.$route.meta.type}`
    },
    isApprovePage () {
      return this.$route.meta.type === 'approval'
    },
  },
  created () {
    this.getFinCenterConfigs()
  },
  methods: {
    ...Vuex.mapActions(['getPlatformUsersIndex', 'getPlatformUsersDetail']),
    ...request.map(['getCustomerReceiptDetail']),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('getNewReceivedPaymentTable', params)
    },
    getReceivedPaymentSummary (params) {
      return request.page('getReceivedPaymentSummary', params)
    },
    onExportSearch () {
      this.$export('回款明细导出-' + moment().format('HHmmss'), {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: this.getTableData,
        requestParams: this.search,
        getResponseData: (data) => {
          data.data.forEach(item => {
            item.type_txt = this.collectionTypeText[item.type]
            item.received_company = this.paymentCompanies[item.our_company_id]
            item.received_date = this.formatOnlyDate(item.received_date)
            item.receipt_related_status = this.receiptRelatedStatus[item.receipt_related_status]
            item.received_bank_info = item.company_bank_info.name + '/' + item.company_bank_info.number
            item.customer_number = item.customer_name + '/' + item.customer_number
          })
          return data
        },
      })
    },
    onExportRelatedDetail () {
      this.$export('回款核销明细-' + moment().format('HHmmss'), {
        fileHeader: this.exportRelatedHeader,
        total: this.pagination.total,
        request: (params) => { return request.page('exportCollectionRelatedDetail', params) },
        requestParams: this.search,
        getResponseData: (data) => {
          data.data.forEach(item => {
            item.type_txt = this.collectionTypeText[item.type]
            item.received_company = this.paymentCompanies[item.our_company_id]
            item.received_date = this.formatOnlyDate(item.received_date)
            item.receipt_related_status = this.receiptRelatedStatus[item.receipt_related_status]
            item.received_bank_info = item.company_bank_info.name + '/' + item.company_bank_info.number
            item.customer_number = item.customer_name + '/' + item.customer_number
          })
          return data
        },
      })
    },
    showSummaryVisible () {
      request.page('getReceivedPaymentSummary', removeEmptyParams(this.search)).then(({data}) => {
        this.paymentSummary = data
        this.summaryVisible = true
      })
    },
    getFinCenterConfigs () {
      return request.common('getFinCenterConfigs').then(({data}) => {
        this.setupPaymentCompany(data)
      })
    },
    setupPaymentCompany (data) {
      this.paymentCompanies = data.payment_apply_our_company_source.reduce((o, k) => {
        o[k.id] = k.name
        return o
      }, {})
    },
    customerRemoteMethod (query) {
      return request.common('getCustomerTable', {keyword: query.name, type: [10, 70]})
    },
    getCustomerInfoRemote () {
      return request.common('getCustomerDetail', {id: this.search.customerid})
    },
    receiptInfoForRemote (query) {
      return request.common('receiptInfoForRemoteSearch', {keyword: query.company_name})
    },
    showForceFinish (row) {
      this.currentCollection = row
      this.forceFinishVisible = true
    },
    closeForceFinishDialog () {
      this.currentCollection = {}
      this.forceFinishVisible = false
    },
    getRemovedEmptySearch () {
      return removeEmptyParams(_.cloneDeep(this.search))
    },
    exportCollectionList () {
      const searchParams = this.getRemovedEmptySearch()
      this.getTableData({...searchParams, per_page: 1}).then((res) => {
        if (res.data.total === 0) {
          this.$alert('当前查询条件下没有回款数据，请调整搜索条件后再导出数据', '提示', {type: 'warning'})
          return
        }
        this.$confirm('确定导出回款列表数据？', '提示', {type: 'warning'}).then(() => {
          request.common('exportCollectionListApi', this.getRemovedEmptySearch()).then((res) => {
            this.$confirm('任务创建成功, 是否前往批量任务页面？', '提示', {type: 'success'}).then(() => {
              this.$router.push({path: '/batch-jobs/finance-export-jobs'})
            })
          })
        })
      })
    },
    exportCollectionDetail () {
      const searchParams = this.getRemovedEmptySearch()
      this.getTableData({...searchParams, per_page: 1}).then((res) => {
        if (res.data.total === 0) {
          this.$alert('当前查询条件下没有回款数据，请调整搜索条件后再导出数据', '提示', {type: 'warning'})
          return
        }
        this.$confirm('确定导出回款核销明细数据？', '提示', {type: 'warning'}).then(() => {
          request.common('exportCollectionDetailApi', this.getRemovedEmptySearch()).then((res) => {
            this.$confirm('任务创建成功, 是否前往批量任务页面？', '提示', {type: 'success'}).then(() => {
              this.$router.push({path: '/batch-jobs/finance-export-jobs'})
            })
          })
        })
      })
    },
    fetchOurCompanies (params) {
      return request.common('getFinCenterOurCompaniesTable', params)
    },
    getOurCompaniesDetail (id) {
      return request.common('getFinCenterOurCompaniesDetail', id).then(data => {
        data.data.id = String(data.data.id)
        return data
      })
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/received-payment/pages/ReceivedPaymentTable.vue